import React, { Component } from 'react'
// import { NavLink } from 'react-router-dom'
import NavLink from '../components/LinkHack'
import PropTypes from 'prop-types'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import shortid from 'shortid'
import Search from './Search'

@inject('user', 'wishlist', 'modals', 'notifications')
@observer
class Header extends Component {
  static toggleMenu () {
    if (window.innerWidth <= 1024) {
      document.body.classList.toggle('js-menu-opened')
      document.body.classList.remove('js-search-opened')
      document.body.scrollIntoView()
    }
  }

  static toggleSearch () {
    if (window.innerWidth <= 1024) {
      document.body.classList.toggle('js-search-opened')
      document.body.classList.remove('js-menu-opened')
      document.body.scrollIntoView()
    }
  }

  handleOnclickModal = (event) => {
    event.preventDefault()

    document.body.classList.toggle('js-modal-opened')
    document.body.scrollIntoView()

    this.props.modals.setModal('LoginModal')
  }

  handleOnclickSingInFirst = (event) => {
    const {user} = this.props

    console.log(' - event:', event)

    if (user.login) {
      return
    }

    event.preventDefault()

    document.body.classList.toggle('js-modal-opened')
    document.body.scrollIntoView()

    this.props.modals.setModal('LoginModal', '/create-experience')
  }

  handleOnclickSignOut = (event) => {
    event.preventDefault()
    this.props.user.clean()
    this.props.wishlist.clean()
    // this.props.history.push('/')
    location.replace('/')
  }

  render () {
    const {user, notifications} = this.props

    let image_url = user.image_url
    let image_style = image_url
      ? { backgroundImage: 'url(' + image_url + ')' }
      : {}

    return (

      <header className='b-header'>
        <div className='b-header-inner'>
          <button className='b-header-search-button'
                  type='button'
                  onClick={Header.toggleSearch}
          />

          <NavLink to='/' className='b-header-logo' />

          <button className='b-menu-switcher'
                  type='button'
                  onClick={Header.toggleMenu}>
            <div className='b-menu-switcher-inner'>
              <div className='b-menu-switcher-line' />
              <div className='b-menu-switcher-line' />
              <div className='b-menu-switcher-line' />
            </div>
          </button>

          <div className='b-header-menu'>
            {/*
            {Object.keys(items).map((key, index) =>
              <NavLink key={shortid.generate()} to={items[key]}
                       className='b-header-menu-item'>{key}</NavLink>
            )}
            */}
            <NavLink key={shortid.generate()}
                     to={'/search'}
                     className='b-header-menu-item'>Suche</NavLink>
            <NavLink key={shortid.generate()}
                     to={'/create-experience'}
                     className='b-header-menu-item'
                     onClick={this.handleOnclickSingInFirst}>Erlebnis erstellen</NavLink>
            <NavLink key={shortid.generate()}
                     to={'/help'}
                     className='b-header-menu-item'>Hilfe</NavLink>
            {user.login
              ? [<NavLink className='b-header-menu-item b-header-menu-item_user'
                          to='/profile'
                    key={shortid.generate()}>
                  <span className={!notifications.has_unread_notification
                    ? 'b-header-menu-item-user-image'
                    : 'b-header-menu-item-user-image b-header-menu-item-user-image_with-dot'}
                        style={image_style} />
                  {user.shortName}
                </NavLink>,
                <button className='b-header-menu-item b-header-menu-item_sing-out'
                        title='Sign out'
                        key={shortid.generate()}
                        onClick={this.handleOnclickSignOut} />]
              : <button className='b-header-menu-item'
                        type='button'
                        onClick={this.handleOnclickModal}>Login&nbsp;/ Signup</button>
            }
          </div>

          <div className='b-header-search'>
            <Search
              type='form'
              redirect={true}
            />
          </div>
        </div>
      </header>
    )
  }
}

Header.propTypes = {
  history: PropTypes.any,
  location: MobxPropTypes.objectOrObservableObject,
  user: MobxPropTypes.observableObject,
  wishlist: MobxPropTypes.observableObject,
  modals: MobxPropTypes.observableObject,
  notifications: MobxPropTypes.observableObject
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js